<script>
    import { page, modal } from '../store/nav';
    import { stores } from '../store/stores';
    import { lists } from '../store/lists';
    import { createId } from "../js/helper";

    import { recentIDB } from "../store/recent";
    import { idb } from '../db';

    export let list_uid;
    export let name;

    let newStore = {
      uid: createId.xs(),
      name: name,
      logoId: "de55"
    };

    const addNewStore = () => {
      stores.add(newStore);
      recentIDB.add(`stores`,newStore);
      lists.editSingleField(list_uid, 'storeUid', newStore.uid);
      lists.editSingleField(list_uid, 'storeLogo', newStore.logoId);
      lists.editSingleField(list_uid, 'storeName', newStore.name.toLowerCase());
      idb.save(`pc_lists`, $lists)
      modal.close();
      page.back(`/lists/items?list_uid=${list_uid}`);
    };
</script>
<section class="flex flex-col space-y-7">
  <section class="mt-5 form-input-text relative h-16 text-primary">
    <span class="absolute inset-y-0 left-0 h-16 z-10 flex items-center px-2 ">    
       <div class="bg-primary rounded-2xl w-12 h-12"><img src="/img/stores/de55.png" class="m-auto w-8 mt-2" alt=""></div>
    </span>

    <input type="text" style="width: 100%;" bind:value={newStore.name} class="z-0 h-16 pl-20 text-2xl border-primary border placeholder-primary rounded-3xl focus:caret-agrume focus:border-primary focus:ring-1 focus:ring-primary focus:outline-none focus:placeholder-white" placeholder="Item name" autocomplete="off" >
  </section>
  <div class="bg-secondary h-16 rounded-3xl text-center text-primary flex items-center justify-center" on:click={addNewStore}>Add new Store</div>
</section>
